import { useContext } from 'react';
import { ToastContext } from './toast-context';
/** Zugriff auf das Toast-System. Erfordert `<ToastProvider>`. */
export function useToast() {
    const ctx = useContext(ToastContext);
    if (!ctx) {
        throw new Error('useToast() muss innerhalb von <ToastProvider> verwendet werden.');
    }
    return ctx;
}
